import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { bindPromiseCreators } from 'redux-saga-routines';
import { reduxForm, submit, Form } from 'redux-form/immutable';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  PostalCodeElement,
  injectStripe,
} from 'react-stripe-elements';
import StripeElementWrapper from '../../../Common/Stripe/StripeElementWrapper';

import ReduxDialog from '../../../Common/ReduxDialog';

import styles from './styles';

import { showDialog, hideDialog, showError } from '../../../../redux/actions/dialogs';
import { CREDIT_CARD_DIALOG } from '../../../../redux/constants/dialogs';
import { updatePaymentSourcePromise } from '../../../../redux/routines';
import { getDialogContextValue } from '../../../../redux/selectors';

class CreditCardDialog extends Component {
  handleSubmit = () => {
    const { stripe, updatePaymentSource, hideDialog, onSave } = this.props;

    stripe.createToken().then(({ token: { id } }) => {
      console.log('Received Stripe token:', id);
      return updatePaymentSource({ token: id });
    }).then(() => {
      if (onSave) {
        onSave();
      }

      hideDialog(CREDIT_CARD_DIALOG);
    });
  };

  render() {
    const { hideDialog, submit, stripe } = this.props;

    console.log('stripe', stripe);

    const actions = [
      <Button
        key="cancel"
        variant="text"
        color="primary"
        onClick={() => hideDialog(CREDIT_CARD_DIALOG)}
      >Cancel</Button>,
      <Button
        key="save"
        variant="contained"
        type="button"
        color="primary"
        onClick={() => submit()}
      >Save</Button>,
    ];

    return (
      <ReduxDialog
        title="Payment Information"
        actions={actions}
        name={CREDIT_CARD_DIALOG}
        bodyStyle={styles.body}
        maxWidth="sm"
        fullWidth
      >
        <Form onSubmit={this.handleSubmit} style={styles.form}>
          <Grid container spacing={8}>
            <Grid item xs={12}>
              <StripeElementWrapper label="Card Number" component={CardNumberElement}/>
            </Grid>
          </Grid>
          <Grid container spacing={8}>
            <Grid item xs>
              <StripeElementWrapper label="Expiry" component={CardExpiryElement}/>
            </Grid>
            <Grid item xs>
              <StripeElementWrapper label="CVC" component={CardCVCElement}/>
            </Grid>
            <Grid item xs>
              <StripeElementWrapper label="Postal Code" component={PostalCodeElement}/>
            </Grid>
          </Grid>
        </Form>
      </ReduxDialog>
    );
  }
}

CreditCardDialog.propTypes = {
  showDialog: PropTypes.func.isRequired,
  hideDialog: PropTypes.func.isRequired,
  onSave: PropTypes.func,
};

const form = reduxForm({
  form: CREDIT_CARD_DIALOG,  // a unique identifier for this form
  onSubmit: (values, dispatch, props) => {
    console.log('props', props.stripe);
    // props.stripe.createToken({ name: 'Jenny Rosen' }).then(({ token }) => {
    //   console.log('Received Stripe token:', token);
    // });
    //   console.log('submit', values.toJS());
    //   const data = {
    //     number: values.get('number'),
    //     cvc: values.get('cvc'),
    //     exp_month: values.get('expiryMonth'),
    //     exp_year: values.get('expiryYear'),
    //   };
    //
    //   return new Promise((resolve, reject) => {
    //     Stripe.createToken(data, (status, response) => {
    //       console.log('status', status);
    //       if (response.error) {
    //         console.error('error', response.error);
    //         reject(new SubmissionError(response.error.message));
    //       } else {
    //         // resolve(AccountsService.savePaymentSource(response.id));
    //         console.log('response', response);
    //         const token = response.id;
    //         resolve(token);
    //       }
    //     });
    //   });
  },
  onSubmitSuccess: (token, dispatch, props) => {
    // props.onRequestClose({ token });
    props.hideDialog(CREDIT_CARD_DIALOG);
  },
  onSubmitFail: (error, dispatch) => {
    console.log('error', error);
    dispatch(showError('Payment Error', error));
  },
})(injectStripe(CreditCardDialog));

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({
      showDialog,
      hideDialog,
      submit,
    }, dispatch),
    ...bindPromiseCreators({
      updatePaymentSource: updatePaymentSourcePromise,
    }, dispatch),
  };
}

function mapStateToProps(state) {
  return {
    onSave: getDialogContextValue(state)(CREDIT_CARD_DIALOG, 'onSave'),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Admin/Billing/CreditCardDialog/index.js